<template>
  <div style="min-height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container top-spacing colum">
      <div>
        <div class="navbar-container " style="width: 100%;">
          <div class="title-section desktop">
            <p style="font-weight: 600; font-size: 20px">
              {{ $t("history") }}
            </p>
          </div>
          <div class="filter-container-booked">
            <div class="mr-20">
              <p class="mb-5">{{ $t("wap.text180") }}</p>
              <div class="d-flex flex-wrap">
                <button
                  v-for="(item, index) in statusFilter"
                  @click="handleStatus(item.value)"
                  :key="index"
                  :class="{ 'button-active': item.value == query.type }"
                >
                  {{ item.label }}
                </button>
              </div>
            </div>
            <div style="position: relative;">
              <p class="mb-5">{{ $t("time") }}</p>
              <div style="position: relative;" class="d-flex flex-wrap">
                <button
                  v-for="(item, index) in arrTime"
                  @click="handleTime(item.value)"
                  :key="index"
                  :class="{ 'button-active': item.value == query.time }"
                >
                  {{ item.label }}
                </button>
                <div class="date-picker">
                  <el-date-picker
                    popper-class="popper-date-picker-custom"
                    ref="datePicker"
                    v-model="datePicker"
                    @change="handleFilterByDate"
                    type="daterange"
                    value-format="timestamp"
                    align="right"
                  ></el-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-booked">
          <div
            style="transform: translateY(100px);"
            v-loading="loadingData"
          ></div>

          <div style="text-align: center; margin-top: 30px" v-if="isEmptyBk">
            <img style="margin-left:10px" :src="icons.Emoij" alt="" />
            <p class="fw-cv2" style="text-align: center; margin-top: 20px">
              {{ $t("noBooking") }}
            </p>
          </div>
          <div v-else>
            <p
              class="c-bold-text text-center c-red-text text-hotline"
              style="line-height: normal; margin-bottom: 15px"
            >
              {{ $t("needCancel") }}
            </p>
            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="8"
                v-for="(booked, index) in listBooked"
                :key="index"
              >
                <wait-confirm :object-data="booked" :is-active="+isActive" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
import frame from "@/assets/img/svg/Frame.svg";
import Up from "@/assets/img/svg/up.svg";
import Emoij from "@/assets/img/svg/emoij.svg";
import WaitConfirm from "@/views/pages/wapV2/history/components/WaitConfirm.vue";
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import TeeTimeResource from "@/views/api/wapV2/tee-time.js";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    WaitConfirm,
    MainNavBarWapV2
  },
  bodyClass: "history-booked",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.getHistoryBooked();
  },
  data() {
    return {
      statusFilter: [
        { value: 0, label: this.$t("all") },
        { value: 1, label: this.$t("waitForConfirmation") },
        { value: 2, label: this.$t("waitForPayment") },
        { value: 3, label: this.$t("paid") }
      ],
      arrTime: [
        { value: 0, label: this.$t("all") },
        { value: 1, label: this.$t("wap.text181") },
        { value: 2, label: this.$t("wap.text182") },
        { value: 3, label: this.$t("wap.text183") }
      ],
      infoHeader: {
        title: this.$t("history"),
        isShowHomeIcon: true
      },
      isActive: 0,
      isLatest: true,
      bg: getBackGround(),
      datePicker: "",
      listBooked: [],
      query: { page: 1, limit: 50, type: 0, version: 2, time: 0 },
      loadingData: false,
      isEmptyBk: false,
      icons: {
        frame,
        Up,
        Emoij
      }
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["bgHeader"]),
    buttonText() {
      return this.isLatest ? this.$t("farthestDate") : this.$t("nearestDate");
    }
  },
  methods: {
    handleStatus(status) {
      this.query.type = status;
      this.getHistoryBooked();
    },
    handleTime(status) {
      this.query.time = status;
      if (status == 0) {
        delete this.query.created_at_from;
        delete this.query.created_at_to;
      } else if (status == 1) {
        this.query.created_at_from = moment()
          .subtract(7, "days")
          .valueOf();
        this.query.created_at_to = moment().valueOf();
      } else if (status == 2) {
        this.query.created_at_from = moment()
          .subtract(30, "days")
          .valueOf();
        this.query.created_at_to = moment().valueOf();
      } else if (status == 3) {
        this.$refs.datePicker.focus();
      }
      this.getHistoryBooked();
    },
    handleFilterByDate(val) {
      if (val) {
        const [val1, val2] = val;
        this.query.created_at_from = val1;
        this.query.created_at_to = val2;
        this.getHistoryBooked();
      }
    },
    async getHistoryBooked() {
      this.loadingData = true;

      const query = this.query;
      TeeTimeResource.historyBooked(query)
        .then(res => {
          if (res.error_code !== 0) return;
          this.listBooked = res.data;
          if (this.listBooked.length === 0) {
            this.isEmptyBk = true;
          } else {
            this.isEmptyBk = false;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    scrollTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss">
.popper-date-picker-custom {
  position: absolute;

  .el-picker-panel__body {
  }
}
.btn-insurance-container {
  width: 80%;
  max-height: 25px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid v-bind("bg.c_border2");
  border-radius: 100px;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .popper-date-picker-custom {
    width: auto !important;
    left: 0 !important;
    .popper__arrow {
      display: none !important;
    }
    .el-picker-panel__body {
      min-width: auto !important;
      display: flex;
      flex-direction: column;
      .el-date-range-picker__content {
        width: 100% !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.date-picker {
  width: 1px;
  height: 1px;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  top: -10px;
  right: 100px;
}
.filter-container-booked {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  p {
    font-weight: 600;
  }
  button {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 12px;

    border: 1px solid #999999;
    border-radius: v-bind("bg.b_radius2");
    padding: 5px 10px;
  }
  .button-active {
    background-color: v-bind("bg.c_border");
    color: #ffff;
    border: 1px solid v-bind("bg.c_border");
  }
}
.bg-action {
  background: v-bind("bg.c_border");
}
.navbar-container {
}
.top-spacing {
  padding-top: 100px;
}
.icon-frame {
  color: #999999;
  margin: 0 10px;
  flex-shrink: 0;
}

.button-add {
  width: 345px;
  height: 40px;
}

.icon-search {
  color: #999999;
  margin-left: 12px;
}

.tab-all {
  display: flex;
  justify-content: center;
}

.member {
  position: absolute;
  display: contents;
}

.border-search-bar {
  max-width: 100%;
  padding-bottom: 10px;
  //display: flex;
}

.search-bar-container {
  background: v-bind("bg.c_background1");
  border: 0.87px solid v-bind("bg.c_border3");
  border-radius: 100px;
  height: 40px;
  display: flex;
  align-items: center;
}
.title-section {
  width: 100%;
  //margin-top: 10px;
  text-align: center;
  margin-bottom: 20px;
}
.title {
  font-weight: 600;
  font-size: 18px;
}
.full-width {
  width: 100%;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .title-h3 {
    font-size: 14px !important;
  }
  .time-container {
    display: flex;
    align-items: center;
    margin: 0 5px !important;
  }
  .text-time {
    font-size: 13px;
  }

  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .border-search-bar {
    max-width: 100%;
    padding-left: 10px;
    //display: flex;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .text-hotline {
    font-size: 12px;
  }

  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
  .filter-container-booked {
    justify-content: start;
    p {
      font-weight: 600;
    }
    button {
      font-size: 10px;
      padding: 3px 10px;
    }
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .title-section {
    display: none;
  }
}
</style>
